export type Flow = {
    id: number;
    status: FlowStatus;
    name: string;
    config: FlowConfig;
    code: string;
};

export const DRAFT_FLOW_STATUS = 'draft';
export const PUBLISHED_FLOW_STATUS = 'published';

const flowStatuses = [DRAFT_FLOW_STATUS, PUBLISHED_FLOW_STATUS] as const;

export type FlowStatus = (typeof flowStatuses)[number];

export type FlowConfig = {
    id: number;
    code: string;
    page: string;
    targetNodeSelector?: string | null;
    objectives?: string[] | null;
    type: FlowConfigType;
    eyeCatcher?: FlowConfigEyeCatcher;
    player: FlowConfigPlayer<FlowConfigPlayerVideo>;
};

export type FlowConfigType = 'overlay' | 'inline';

export type FlowConfigTemplateString =
    | string
    | { default: string; template: string };

export type FlowConfigEyeCatcher = {
    style: Record<string, Record<string, string>>;
    title: FlowConfigTemplateString;
    playbackRate?: number;
    presentationDelay?: number;
    presentationScrollOffset?: number;
    urlMap: {
        /**
         * @deprecated Not in use anymore, will be removed in future versions
         */
        gif: string;
        mp4: string;
        webm?: string;
        // NOTE: If present, eye catcher will show captions instead of title
        vtt?: string;
    };
};

export type FlowConfigPlayer<T> = {
    style: Record<string, Record<string, string>>;
    videos: T[];
    autoPlay?: boolean;
    autoPlayDelay?: number;
    brandingVariant?: number;
    themeVariant?: number;
    sizeVariant?: number;
    soundPreferenceVariant?: 1 | 2;
};

export const UNKNOWN_CONTENT_VARIANT = 0;
export const REAL_FOOTAGE_AND_REAL_AUDIO_CONTENT_VARIANT = 1;
export const GENERATED_FOOTAGE_AND_REAL_AUDIO_CONTENT_VARIANT = 2;
export const GENERATED_FOOTAGE_AND__GENERATED_AUDIO_CONTENT_VARIANT = 3;
export const REAL_FOOTAGE_AND_GENERATED_AUDIO_CONTENT_VARIANT = 4;

// NOTE: See backend enums for more details
//   /app/Enums/ContentLabel.php
export const contentVariantList = [
    UNKNOWN_CONTENT_VARIANT,
    REAL_FOOTAGE_AND_REAL_AUDIO_CONTENT_VARIANT,
    GENERATED_FOOTAGE_AND_REAL_AUDIO_CONTENT_VARIANT,
    GENERATED_FOOTAGE_AND__GENERATED_AUDIO_CONTENT_VARIANT,
    REAL_FOOTAGE_AND_GENERATED_AUDIO_CONTENT_VARIANT,
] as const;

export type FlowConfigPlayerVideoContentVariant =
    (typeof contentVariantList)[number];

export type FlowConfigPlayerVideo = {
    id: string;
    url: string;
    webmUrl?: string;
    subtitles: string;
    authorName?: string;
    authorRole?: string;
    playbackRate?: number;
    buttonPresentationDelay?: number;
    contentVariant?: FlowConfigPlayerVideoContentVariant;
    text: FlowConfigTemplateString;
    title: FlowConfigTemplateString;
    buttons: FlowConfigPlayerVideoButton[];
    // NOTE: For future use!
    form?: FlowConfigPlayerVideoForm;
};

export type FlowConfigPlayerVideoButton = {
    id: string;
    label: string;
    actionType: ActionType | string;

    // TODO: Revisit TS error that actual type is casing
    // | { href: string; target?: string; hidePlayerOnNavigate: boolean }
    // | { videoId: string }
    // | Record<string, string>;

    actionPayload: Record<string, string | boolean | number>;
    style?: Record<string, string>;
};

// TODO: Update
export type FlowConfigPlayerVideoForm = any;

export const OPEN_VIDEO_ACTION_TYPE = 'custom:open_video_button';
export const HIDE_PLAYER_ACTION_TYPE = 'custom:hide_player_button';

export const actionTypeList = [
    OPEN_VIDEO_ACTION_TYPE,
    HIDE_PLAYER_ACTION_TYPE,
] as const;

export type ActionType = (typeof actionTypeList)[number];
